import { gql } from '@apollo/client';

export const GET_STANDARDIZED_ADDRESS_DETAIL = gql`
  query GetStandardizedAddressDetail($id: Long!) {
    getStandardizedAddressDetail(id: $id) {
      id
      unifiedStreetAddress  
      fullStandardAddress
      latitude
      longitude
      zipcode
      primaryNumber
      streetName
      unitType
      unitNumber
      cityName
      stateAbbreviation
      updatedAt
      isBlacklisted
      accessCodes {
        id
        codeType
        accessCode
        status
      }
    }
  }
`;

export interface AccessCodeType {
  id: string;
  codeType: string;
  accessCode: string | null;
  status: number; // 0-待验证，1-可用，2-不可用
}

export interface StandardizedAddressDetailType {
  id: string;
  unifiedStreetAddress: string;
  fullStandardAddress: string;
  latitude: string | null;
  longitude: string | null;
  zipcode: string;
  primaryNumber: string | null;
  streetName: string;
  unitType: string | null;
  unitNumber: string | null;
  cityName: string | null;
  stateAbbreviation: string;
  updatedAt: string;
  isBlacklisted: boolean;
  accessCodes: AccessCodeType[];
}

export interface GetStandardizedAddressDetailResponse {
  getStandardizedAddressDetail: StandardizedAddressDetailType | null;
}

